import { render, staticRenderFns } from "./AddEditAcademicPosition.vue?vue&type=template&id=784fbab6"
import script from "./AddEditAcademicPosition.vue?vue&type=script&lang=js"
export * from "./AddEditAcademicPosition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports